/**
 * Component: Select UI
 */

 import $ from 'jquery';

 const selectors = {
   main_container: '.karmoon-selector',
   select_field: '.karmoon-select',
   btn_select: '.karmoon--btn-select',
   select_container: '.karmoon-option-select--container',
   select_container_list: '.karmoon-option-select--container__ul',
 };
 
 export default () => {
   // build list
   $(selectors.main_container).each(function (e) {
     const $this = $(this);
     const optArray = [];
     // console.log($this.find(`${selectors.select_field} option`).length);
     $this.find(`${selectors.select_field} option`).each(function (e) {
       const img = $(this).data('thumbnail');
       const shade = $(this).parent().data('shade');
       const text = this.innerText;
       const value = $(this).val();
       let item;
       if (shade) {
         item = `<li><span class="shade"><img src="${img}" alt="" value="${value}"/></span><span class="title">${text}</span></li>`;
       } else {
         item = `<li><span value="${value}" class="title">${text}</span></li>`;
       }
       optArray.push(item);
     });
     $this.find(selectors.select_container_list).html(optArray);
     $this.find(selectors.btn_select).html(optArray[0]);
 
     // change fake select
     $this.find(selectors.select_field).on('change', function (e) {
       $this.find(`${selectors.btn_select} .title`).text($(this).val());
       $this
         .find(`${selectors.btn_select} img`)
         .attr('src', $(this).find(':selected').data('thumbnail'));
       if ($(this).val().indexOf('select') !== -1) {
         $this.find(selectors.btn_select).removeClass('not-value');
       }
     });
   });
 
   // change main hidden select on click
   $(document).on(
     'click',
     `${selectors.select_container_list} li`,
     function (e) {
       let value = $(this).find('img').attr('value');
       const container = $(e.target).closest(selectors.main_container);
       let valueHash;
 
       if (value) {
         valueHash = `variant-${value.toLowerCase().replace(/ /g, '-')}`;
       } else {
         value = $(this).find('span').attr('value');
         valueHash = `variant-${value.toLowerCase().replace(/ /g, '-')}`;
       }
 
       Karmoon.EventBus.emit('variantChanged:changed', valueHash);
 
       container
         .find(`${selectors.select_field} option[value="${value}"]`)
         .prop('selected', true);
       container.find(selectors.select_container).hide();
       container
         .find(selectors.select_field)[0]
         .dispatchEvent(new Event('change'));
       container.find(selectors.btn_select).removeClass('not-value');
     },
   );
 
   // show list
   $(document).on('click', selectors.btn_select, (e) => {
     const dropdown = e.target.closest(selectors.btn_select);
 
     $(dropdown).toggleClass('active');
     $(dropdown)
       .closest(selectors.main_container)
       .find(selectors.select_container)
       .toggle();
   });
 
   $('body').on('click', (evt) => {
     if (evt.target.id === selectors.select_container) {
       return;
     }
 
     if ($(evt.target).closest(selectors.btn_select).length) {
       return;
     }
 
     $(selectors.btn_select).removeClass('active');
     $(selectors.select_container).hide();
   });
 
   $(document).on('keydown', (e) => {
     if (e.keyCode === 27) {
       $(selectors.select_container).hide();
     }
   });
 };